"use client";

import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const caseStudies = [{
  number: "01",
  category: "PINTURA & REVESTIMENTO",
  title: "Lubrificação e Arrefecimento para Conformação de Metais",
  body: "Obtenha salas de prensas mais limpas, redução do desperdício de lubrificante e da sobrespray, e maior precisão com bicos de lubrificação combinados com sistemas AutoJet®. Beneficie de lubrificação de elevada velocidade e direcionada com precisão em operações de estampagem, corte e conformação. Características Principais: Pulverização programável e sob demanda Aplicação por zonas para melhor controlo Redução do consumo de fluidos e da sobrespray.",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.06.42.png?v=7mdl60nljb4",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.06.42.png?v=tt1ldt3aauc-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.06.42.png?v=2korr8e5a5d-wvc-sizes",
  alt: "Sistema de pintura e revestimento de alta precisão para a indústria automóvel",
  href: "/AutomotiveManufacturingSuccessCasePage"
}, {
  number: "02",
  category: "LUBRIFICAÇÃO",
  title: "Limpeza e Enxaguamento de Peças",
  body: "As peças de veículos, como componentes de motorização, peças fundidas e estampadas, exigem uma limpeza fiável e de elevado impacto. Minimize o consumo de água, produtos químicos e energia utilizando os nossos bicos VeeJet®, FloodJet®, FullJet® e WashJet®, que proporcionam cobertura consistente numa vasta gama de pressões e caudais — ideais para sistemas de limpeza em linha, de armário ou robóticos.\nCaracterísticas Principais:\n\nCobertura de pulverização fiável e entrega de impacto para peças com geometrias complexas\nAmpla gama de caudais e pressões para se adaptar a qualquer estação de limpeza\nConcebidos para serviço intensivo e fácil integração em todos os tipos de linhas de limpeza",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.06.48.png?v=r094ba3od98",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.06.48.png?v=vkkvhfb4y7e-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.06.48.png?v=4j2hp4e32wp-wvc-sizes",
  alt: "Sistema de lubrificação automatizado em linha de montagem automóvel",
  href: "/AutomotiveManufacturingSuccessCasePage"
}, {
  number: "03",
  category: "ESTANQUEIDADE & QUALIDADE",
  title: "Pré-tratamento e Revestimento",
  body: "Um desempenho fiável é essencial nas operações de preparação de superfícies e pintura. Os nossos bicos de cone cheio, jato plano e edutores são projetados para a aplicação de elevada eficiência de revestimentos de conversão, enxaguamentos e químicos de pré-tratamento.\n\nCobertura consistente em geometrias complexas\nConstrução durável para ambientes agressivos\nBaixa manutenção para redução de tempos de paragem\nPré-tratamento químico mais eficaz e consistente",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.06.52.png?v=8tzvgied2nd",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.06.52.png?v=qtvqq99c4i-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.06.52.png?v=1q9w66ddumv-wvc-sizes",
  alt: "Túnel de teste de estanqueidade e chuva industrial para validação de veículos",
  href: "/AutomotiveManufacturingSuccessCasePage"
}];
export default function Casestudyshowcase() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".vlt-header", {
        opacity: 0,
        y: 24
      });
      gsap.set(".vlt-card", {
        opacity: 0,
        y: 36
      });
      gsap.to(".vlt-header", {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".vlt-header",
          start: "top 85%",
          once: true
        }
      });
      gsap.to(".vlt-card", {
        opacity: 1,
        y: 0,
        duration: 0.85,
        stagger: 0.15,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".vlt-grid",
          start: "top 80%",
          once: true
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".vlt-header", ".vlt-card"], {
        opacity: 1,
        y: 0
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="31429" id="casestudyshowcase" className="bg-background text-foreground py-24 md:py-36 relative overflow-hidden">
      <div ref={container} className="mx-auto max-w-[1360px] px-5 md:px-8 lg:px-12">
        {}
        <div className="vlt-header mx-auto max-w-3xl text-center mb-16 md:mb-20">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-4">
            Aplicações em Fabrico Automóvel
          </span>
          <h2 className="font-default font-semibold text-[clamp(2.25rem,4.5vw,3.75rem)] leading-[1.08] tracking-tight text-foreground">
            Tecnologia de Precisão na Linha de Produção.
          </h2>
        </div>

        {}
        <div className="vlt-grid grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 items-stretch">
          {caseStudies.map((item, i) => <Link className="vlt-card bg-card text-card-foreground border border-border/70 rounded-3xl p-6 lg:p-8 flex flex-col justify-between shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 group underline cursor-pointer underline cursor-pointer" {...item.link}><Link {...item.link}><div key={item.number} data-index={i}>
              <div>
                {}
                <div className="relative aspect-[3/2] w-full overflow-hidden rounded-xl mb-6 bg-muted border border-border/40">
                  <img src={item.image} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>

                {}
                <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-3">
                  {item.number} — {item.category}
                </div>

                {}
                <h3 className="text-xl lg:text-2xl font-bold text-foreground mb-3 leading-snug">
                  {item.title}
                </h3>

                {}
                <p className="text-sm lg:text-base text-muted-foreground leading-relaxed mb-6">
                  {item.body}
                </p>
              </div>

              {}
              <div className="pt-2 border-t border-border/40 mt-2">
                <Link to={item.href} className="inline-flex items-center gap-2 text-sm font-medium text-foreground hover:text-primary transition-colors duration-200 group/link">
                  <span>Saber mais</span>
                  <span className="inline-flex items-center justify-center rounded-lg border border-border/80 w-7 h-7 bg-background group-hover/link:border-primary group-hover/link:bg-primary group-hover/link:text-primary-foreground transition-all duration-200">
                    <ArrowUpRight className="w-3.5 h-3.5" />
                  </span>
                </Link>
              </div>
            </div></Link></Link>)}
        </div>
      </div>
    </section>;
}